import React, { useEffect, useState } from 'react'
import others from '../../../../../../../../../public/assets/img/WomansCategory/others.png'
import aroww from '../../../../../../../../../public/assets/img/WomansCategory/aroww.png'
import star from '../../../../../../../../../public/assets/img/WomansCategory/star.png'
import { WOMEN_FIND_YOUR_STYLE } from 'src/Helpers/Json/WomanCategoryList'
import Link from 'next/link'
import { useAppDispatch } from 'src/store/store'
import { useAuth } from 'src/utils/auth'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import AosAnimation from 'src/utils/AosAnimation'

// import Emptystateimage from "/assets/img/bannerBg.svg";
// import Emptystateimage from "/public/assets/img/emptystateimage/emptystateimage.png";

export default function FindYourStyleWeb({ setsubPage, Cards, setMenStyleData, PageDataFun }) {
  // const [search, setSearch] = useState('')

  const { user }: any = useAuth()
  const dispatch = useAppDispatch()

  const handleRedirect = () => {
    dispatch(
      guestAccountDetailSlice({
        modal: 'authModal',
        isOpen: true,
        id: {
          media: 'https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4',
          modalFor: 'login',
          startWith: 'loginModal',
        },
      }),
    )
  }

  return (
    <React.Fragment>
      {/* <div className="findYourStyles-search-section">
        <div className="container">
          <div className="search-alignment">
            <div className="search-icon-alignment">
              <img src="/assets/icon/Search-grey-icon.svg" />
            </div>
            <div className="search-input-alignment">
              <input
                type="text"
                placeholder="Search style"
                // onChange={(e: any) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div> */}
      <div className="findYourStyles-styles-details-alignment" >
        <div className="container">
          {WOMEN_FIND_YOUR_STYLE.map((style, index) => {
            return (
              <div className="child-styles-details" key={index}>
                <div className="details-heading-alignment third-product">
                  <div className="find-your-style-bg-img">
                    <img src={style?.bannerImage} alt="FindStyleDemoImg" />
                  </div>
                  <div className="fashion-name-alignment">
                    <h5>{style?.name}</h5>
                    <p>{style?.text}</p>
                  </div>
                  <Link
                    href={{
                      pathname: `/fashion/women`,
                      query: { type: 'style', detail: style?.name },
                    }}
                    scroll={false}
                  >
                    <div className="see-all-product-alignment">
                      <a>
                        See All {style?.name} Style <img src="/assets/icon/right-blue-arrow.svg" />
                      </a>
                    </div>
                  </Link>
                </div>
                <>
                <div className="findYourStyle_product_block_empty">
                  <div className="findYourStyle_product_block_empty_details_box">
                    <img src={'/assets/img/emptystateimage/emptystateimage.png'} alt="Emptystateimage"/>
                    <p>We don't have any style selection right now, but check back soon!</p>
                  </div>
                </div>
                {/* <div>
                  <div className="findYourStyle_product_block">
                    <div className="row findYourStyle_product_block_row">
                      {Cards.map((Data, i) => {
                        return Data.parent_fill ? (
                          <React.Fragment key={i}>
                            <AosAnimation animationType="fade-up" duration={2500} delay={250}>
                              <div key={`p${i + 1}`} className="card_col">
                                <div className="cardcover">
                                  <div className="card_top">
                                    <img src={Data.child[0].img.src} alt="card_top_img" />
                                  </div>
                                  <div className="card_bottom">
                                    <div className="card_bottom_cover">
                                      <h4>Plain And Check Shirts</h4>
                                      <p className="amount">
                                        <span className="price">$245</span>
                                        <span className="orignal_price"> $ 425.00 </span>
                                        <span className="discount">40% OFF</span>
                                      </p>
                                      <p className="hike">
                                        <span className="inter">
                                          <img src={others.src} alt="hike" /> Interest
                                        </span>
                                        <span className="incris">
                                          <img src={aroww.src} alt="incris" /> 200%
                                        </span>
                                      </p>
                                      <div className="rating">
                                        <span className="rating_point">4.8</span>
                                        <div className="stars">
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                        </div>
                                        <span className="num">(437)</span>
                                      </div>
                                      <button className="buy_btn" onClick={handleRedirect}>
                                        Buy
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className="cardcover">
                                  <div className="card_top">
                                    <img src={Data.child[1].img.src} alt="card_top_img" />
                                  </div>
                                  <div className="card_bottom">
                                    <div className="card_bottom_cover">
                                      <h4>Plain And Check Shirts</h4>
                                      <p className="amount">
                                        <span className="price">$245</span>
                                        <span className="orignal_price"> $ 425.00 </span>
                                        <span className="discount">40% OFF</span>
                                      </p>
                                      <p className="hike">
                                        <span className="inter">
                                          <img src={others.src} alt="hike" /> Interest
                                        </span>
                                        <span className="incris">
                                          <img src={aroww.src} alt="incris" /> 200%
                                        </span>
                                      </p>
                                      <div className="rating">
                                        <span className="rating_point">4.8</span>
                                        <div className="stars">
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                        </div>
                                        <span className="num">(437)</span>
                                      </div>
                                      <button className="buy_btn" onClick={handleRedirect}>
                                        Buy
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </AosAnimation>
                          </React.Fragment>
                        ) : (
                          <React.Fragment key={i}>
                            <AosAnimation animationType="fade-up" duration={3000} delay={350}>
                              <div className="card_col">
                                <div className="cardcover">
                                  <div className="card_top">
                                    <img src={Data.img.src} alt="card_top_img" />
                                  </div>
                                  <div className="card_bottom">
                                    <div className="card_bottom_cover">
                                      <h4>Plain And Check Shirts</h4>
                                      <p className="amount">
                                        <span className="price">$245</span>
                                        <span className="orignal_price"> $ 425.00 </span>
                                        <span className="discount">40% OFF</span>
                                      </p>
                                      <p className="hike">
                                        <span className="inter">
                                          <img src={others.src} alt="hike" /> Interest
                                        </span>
                                        <span className="incris">
                                          <img src={aroww.src} alt="incris" /> 200%
                                        </span>
                                      </p>
                                      <div className="rating">
                                        <span className="rating_point">4.8</span>
                                        <div className="stars">
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                          <img src={star.src} alt="star" />
                                        </div>
                                        <span className="num">(437)</span>
                                      </div>
                                      <button className="buy_btn" onClick={handleRedirect}>
                                        Buy
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </AosAnimation>
                          </React.Fragment>
                        )
                      })}
                    </div>
                  </div>
                </div> */}
                </>
              </div>
            )
          })}
        </div>
      </div>
    </React.Fragment>
  )
}
